import styled from 'styled-components'

export const Container = styled.main`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #FBFBFB;
`